
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-cc49fc46!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StationaryShop.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StationaryShop.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-cc49fc46!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StationaryShop.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductStationaryAvailability/StationaryShop.vue
// module id = 202
// module chunks = 2